import React from 'react'
import { Lock, Shield } from 'lucide-react'
import { useAuth } from '../../contexts/SupabaseAuthContext'

interface PricingGateProps {
    children: React.ReactNode
    onLoginRequest: () => void
    productName?: string
    variant?: 'dark' | 'light'
}

export const PricingGate: React.FC<PricingGateProps> = ({
    children,
    onLoginRequest,
    productName = "este produto",
    variant = 'dark'
}) => {
    const { isAuthenticated } = useAuth()

    if (isAuthenticated) {
        return <>{children}</>
    }

    return (
        <div className={`
      flex flex-col items-center justify-center py-12 px-6 text-center rounded-3xl border w-full
      ${variant === 'dark'
                ? 'bg-white/5 border-white/10 text-white backdrop-blur-sm'
                : 'bg-white border-gray-100 text-black shadow-xl'}
    `}>
            <div className={`
        w-20 h-20 rounded-full flex items-center justify-center mb-6 backdrop-blur-md
        ${variant === 'dark' ? 'bg-white/10' : 'bg-gray-100'}
      `}>
                <Shield size={40} className={variant === 'dark' ? 'text-white' : 'text-blue-600'} />
            </div>

            <h3 className={`text-3xl font-black mb-3 ${variant === 'dark' ? 'text-white' : 'text-black'}`}>
                ACESSO RESTRITO
            </h3>

            <p className={`mb-8 max-w-sm text-lg ${variant === 'dark' ? 'text-gray-400' : 'text-gray-500'}`}>
                Para visualizar os preços e planos especiais do <strong>{productName}</strong>, é necessário ter uma conta.
            </p>

            <button
                onClick={onLoginRequest}
                className={`
          px-10 py-5 rounded-xl font-black text-lg flex items-center gap-3 transition-all hover:scale-105 active:scale-95 shadow-lg
          ${variant === 'dark'
                        ? 'bg-white text-black hover:bg-gray-200'
                        : 'bg-black text-white hover:bg-gray-800'}
        `}
            >
                <Lock size={20} />
                FAZER LOGIN PARA VER PREÇOS
            </button>

            <p className={`mt-6 text-sm ${variant === 'dark' ? 'text-gray-500' : 'text-gray-400'}`}>
                Cadastro gratuito • Acesso imediato • Sem compromisso
            </p>
        </div>
    )
}
